import {
  IconButton,
  Stack,
  TextField,
} from "@mui/material";
import { EmojisICON, SEND } from "../../../assets/icons";
import { SvgContainer } from "../../../components";

function MessageWriteBar({ onChange, ctnStyle, ...rest }: any) {
  return (
    <Stack
      sx={{ backgroundColor: "#B5BAB526", borderRadius: "12px", position: "absolute", bottom: 25, right: 25, left: 25 }}
      direction="row"
      justifyContent={"space-between"}
      alignItems="center"
      px={1}
    >
      <IconButton sx={{mr: -2}}>
        <EmojisICON />
      </IconButton>

      <TextField
        id="input-with-icon-textfield"
        type="search"
        placeholder="Message"
        color="secondary"
        sx={{
          "& fieldset": { border: "none" },
        }}
        inputProps={{
          style: { height: 15 },
        }}
        style={{
          marginLeft: "1em",
          width: "90%",
          border: "none",
        }}
        onChange={onChange}
        {...rest}
      />

      <IconButton>
        <SvgContainer svg={SEND} color={"#9BA69C"} />
      </IconButton>
    </Stack>
  );
}

export default MessageWriteBar;
